<template>
	<div>
		<Breadcrumbs main="" title=""/>
		<div class="container-fluid">
            <div class="col-sm-12">
                <div v-show="process === 'add'" class="col-sm-6" id="addTruck">
                    <div class="row ml-1" v-b-hover="handleHover">
                        <h2 class="text-primary mt-3">{{ $t('truck.addTruck') }}</h2> 
                        <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="process = 'info' ">&times;</span>
                        <span v-show="isHovered" class="text-danger">{{ $t('truck.cancelReturn')  }} </span>
                    </div>
                    <form class="theme-form">
                        <div class="row">
                            <div class="form-group col-sm-4">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.licensePlate") }}</h4>                                                 
                                <input type="text" id="licensePlate" v-model="licensePlate" required class="form-control" :placeholder="$t('truck.licensePlatePh')" >
                            </div>
                                <div class="form-group col-sm-4">
                                <h4  class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.registExpiryDate") }}</h4>
                                <datepicker 
                                    input-class="datepicker-here form-control digits"  
                                    :disabled-dates="disabledDates"  
                                    :format="format" 
                                    :placeholder="$t('truck.registExpiryDatePh')"
                                    v-model="registExpiryDate" >
                                </datepicker>
                            </div>                                      
                            <div class="form-group col-sm-4">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.vin") }}</h4>                                                 
                                <input type="text" id="vin" v-model="vin" required class="form-control" :placeholder="$t('truck.vinPh')" >
                            </div>   
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-4">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.insurId") }}</h4>
                                <input type="text" id="insurId" v-model="insurId" required :placeholder="$t('truck.insurIdPh')">
                            </div>
                            <div class="form-group col-sm-4">
                                <h4 for="insurExpiryDate" class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.insurExpiryDate") }}</h4>
                                <datepicker 
                                    input-class="datepicker-here form-control digits"  
                                    :disabled-dates="disabledDates"  
                                    :format="format" 
                                    :placeholder="$t('truck.insurExpiryDatePh')"
                                    v-model="insurExpiryDate" >
                                </datepicker>
                            </div>  
                           <div class="form-group col-sm-4">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.type") }}</h4>
                                <input type="text" id="type" v-model="type" required :placeholder="$t('truck.typePh')">
                            </div>                                                                  
                        </div>                        
                        <div class="row">
                            <div class="form-group col-sm-4">
                                <h4  class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.make") }}</h4>
                                <input type="text" id="make" v-model="make" required :placeholder="$t('truck.makePh')">
                            </div>
                            <div class="form-group col-sm-4">
                                <h4  class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.model") }}</h4>
                                <input type="text" id="model" v-model="model" required :placeholder="$t('truck.modelPh')">
                            </div>
                            <div class="form-group col-sm-4">
                                <h4  class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.year") }}</h4>
                                <input type="number" id="year" v-model="year" required :placeholder="$t('truck.yearPh')">
                            </div>                                                              
                        </div>                        
                        <div class="form-group">
                            <button class="btn btn-primary btn-block" style="font-size:20px"  type="button" @click="handleSave">{{ $t('bookingId.saveAdd') }}</button>
                        </div>
                    </form>                                 
                </div>
                <div v-show="process === 'update'" class="col-sm-6" id="editTruck">
                    <div class="row ml-1" v-b-hover="handleHoverEdit">
                        <h4 class="text-danger mt-3">{{ $t('truck.editTruck') }}</h4> 
                        <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="process = 'info' ">&times;</span>
                        <span v-show="isHoveredEdit" class="text-danger">{{ $t('truck.cancelReturn')  }} </span>
                    </div>
                    <form class="theme-form">
                        <div class="row">
                            <div class="form-group col-sm-4">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.licensePlate") }}</h4>                                                 
                                <input type="text" id="editLicensePlate" v-model="editLicensePlate" required class="form-control" :placeholder="$t('truck.licensePlatePh')" >
                            </div>
                                <div class="form-group col-sm-4">
                                <h4  class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.registExpiryDate") }}</h4>
                                <datepicker 
                                    input-class="datepicker-here form-control digits"  
                                    :disabled-dates="disabledDates"  
                                    :format="format" 
                                    :placeholder="$t('truck.registExpiryDatePh')"
                                    :language="th" 
                                    v-model="editRegistExpiryDate" >
                                </datepicker>
                            </div>                                      
                            <div class="form-group col-sm-4">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.vin") }}</h4>                                                 
                                <input type="text" id="editVin" v-model="editVin" required class="form-control" :placeholder="$t('truck.vinPh')" >
                            </div>   
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-4">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.insurId") }}</h4>
                                <input type="text" id="editInsurId" v-model="editInsurId" required :placeholder="$t('truck.insurIdPh')">
                            </div>
                            <div class="form-group col-sm-4">
                                <h4 for="insurExpiryDate" class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.insurExpiryDate") }}</h4>
                                <datepicker 
                                    input-class="datepicker-here form-control digits"  
                                    :disabled-dates="disabledDates"  
                                    :format="format" 
                                    :language="th" 
                                    :placeholder="$t('truck.insurExpiryDatePh')"
                                    v-model="editInsurExpiryDate" >
                                </datepicker>
                            </div>  
                           <div class="form-group col-sm-4">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.type") }}</h4>
                                <input type="text" id="editTypee" v-model="editType" required :placeholder="$t('truck.typePh')">
                            </div>                                                                  
                        </div>                        
                        <div class="row">
                            <div class="form-group col-sm-4">
                                <h4  class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.make") }}</h4>
                                <input type="text" id="editMake" v-model="editMake" required :placeholder="$t('truck.makePh')">
                            </div>
                            <div class="form-group col-sm-4">
                                <h4  class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.model") }}</h4>
                                <input type="text" id="editModel" v-model="editModel" required :placeholder="$t('truck.modelPh')">
                            </div>
                            <div class="form-group col-sm-4">
                                <h4  class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("truck.year") }}</h4>
                                <input type="number" id="editYear" v-model="editYear" required :placeholder="$t('truck.yearPh')">
                            </div>                                                              
                        </div>                        
                        <div class="form-group">
                            <button class="btn btn-warning btn-block" style="font-size:20px"  type="button" @click="handleUpdate">{{ $t('truck.saveEdit') }}</button>
                        </div>
                    </form>                                 
                </div> 
                <div class="col-sm-12">
                    <div class="row ml-1">
                        <h2 class="text-primary mt-1">{{ $t('truck.truckList') }}</h2>   
                        <b-button v-show="process === 'info'" pill href="#addTruck" size="sm" @click="process = 'add' " class="bg-primary mb-4 mx-3 ">
                            <span class="f-w-600 text-white" style="font-size: 18px;">{{ $t('truck.addTruck') }} </span>
                        </b-button>                         
                    </div>
                    <div class="row ">
                        <b-col lg="6" class="my-1">
                            <b-form-group
                            :label="$t('matchTx.filter')"
                            label-for="filter-input"
                            label-cols-sm="3"
                            label-align-sm="right"
                            label-size="lg"
                            class="mb-0"
                            >
                                <b-input-group size="sm">
                                    <b-form-input
                                    id="filter-input"
                                    v-model="filter"
                                    type="search"
                                    :placeholder="$t('matchTx.typeToSearch')"
                                    class="text-info"
                                    style="font-size: 18px;"
                                    ></b-form-input>
                                    <b-input-group-append>
                                    <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                                        {{ $t('matchTx.clear') }}
                                    </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>                            
                        <b-col lg="6" class="my-1">
                            <b-form-group
                            v-model="sortDirection"
                            :label="$t('matchTx.filterOn')"
                            :description= "$t('matchTx.uncheck')"
                            label-cols-sm="3"
                            label-align-sm="right"
                            label-size="lg"
                            class="mb-0"
                            v-slot="{ ariaDescribedby }"
                            >
                            <b-form-checkbox-group
                                v-model="filterOn"
                                :aria-describedby="ariaDescribedby"
                                class="mt-1 text-info"
                                plain
                            >
                                <b-form-checkbox value="licensePlate">{{ $t('truck.licensePlate') }}</b-form-checkbox>                                        
                                <b-form-checkbox value="truckId">{{ $t('truck.truckId') }}</b-form-checkbox>
                            </b-form-checkbox-group>
                            </b-form-group>
                        </b-col>                          
                    </div>          
                    <b-row class="ml-2">
                        <b-table
                            sticky-header
                            head-variant="light"
                            table-variant="success"
                            show-empty
                            sort-icon-left
                            stacked="md"
                            :sort-direction="sortDirection"
                            :filter="filter"
                            :filter-included-fields="filterOn"
                            :items="items"
                            :fields="fields"
                            :tbody-tr-class="rowClass"
                            :current-page="currentPage"
                            :per-page="perPage"
                            @filtered="onFiltered"
                        >
                                                <!-- A virtual column -->
                            <template #cell(index)="data">
                                {{ data.index + 1 }}
                            </template>
                            <template #cell(act)="row" >
                                <b-button  v-show="row.item.active"  size="sm" variant="warning" @click="actStop(row.item)" class="m-1">
                                    {{ $t('bookingId.stop') }}
                                </b-button>
                                <b-button  v-show="!row.item.active" size="sm" variant="success" @click="actAble(row.item)" class="m-1">
                                    {{ $t('company.able') }}
                                </b-button>
                                <b-button  size="sm" variant="warning" @click="actUpdate(row.item)" class="m-1">
                                    {{ $t('container.update')  }}
                                </b-button>                                
                                <b-button size="sm" variant="danger" @click="actDelete(row.item)" class="m-1">
                                    {{ $t('container.delete') }}
                                </b-button>
                            </template>
                            <template #empty>
                                <h5>{{ $t('reuse.noRecord') }}</h5>
                            </template>
                        </b-table>  
                    </b-row>
                    <b-row>
                        <b-col class="my-1 ml-1">
                            <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            class="my-0"
                            ></b-pagination>
                        </b-col>   
                        <b-col sm="3" md="6" class="my-1">
                            <b-form-group
                            :label= "$t('require.perPage')"
                            label-for="per-page-select"
                            label-cols-sm="6"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label-align-sm="right"
                            label-size="sm"
                            class="mb-0"
                            >
                            <b-form-select
                                id="per-page-select"
                                v-model="perPage"
                                :options="pageOptions"
                            ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-modal ref="truck-modal" hide-footer variant="danger"  :title="$t('truck.repeatTruck')">
                        <div class="d-block text-center">
                            <h5>{{ $t('truck.repeatTruckMsg') }}</h5>
                        </div>
                        <b-button class="my-2" style="font-size:18px;" variant="outline-warning" block @click="hideModal">
                            {{ $t('truck.ok') }}
                        </b-button>                            
                    </b-modal>                 
                </div>               
            </div>
        </div>
    </div>
</template>
<script>
import { deleteItem,updateActive ,getData, saveWithId} from "../../firebase"
import {en, th} from 'vuejs-datepicker/dist/locale'
export default {

	data(){
		return{
            en: en,
            th: th,
            process : "info",
            isHovered: false,
            isHoveredEdit: false,
            licensePlate: '',
            vin: '',
            make: '',
            model: '',
            year: null, // Use null initially for numbers
            type: '',
            registExpiryDate: '', // Will be a string from date input        
            insurId: '',
            insurExpiryDate: '',
            active: true, // Default to active
            compId : '',
            disabledDates: {
                to: new Date(),
            },
            format: "yyyy-MM-dd",
            editTruckId: '',
            editLicensePlate: '',
            editVin: '',
            editMake: '',
            editModel: '',
            editYear: null, // Use null initially for numbers
            editType: '',
            editRegistExpiryDate: '', // Will be a string from date input        
            editInsurId: '',
            editInsurExpiryDate: '',
            editActive: true,
            items: [],
            fields: [
                { key: 'truckId', label: this.$t('truck.truckId'),variant: 'secondary', sortable: true, }, 
                { key: 'licensePlate', label: this.$t('truck.licensePlate'), variant: 'primary', sortable: true, }, 
                { key: 'registExpiryDate', label: this.$t('truck.registExpiryDate'), variant: 'primary', sortable: true, 
                    formatter: value => {
                        return this.$moment(value).format("DD-MM-YYYY")
                }},           
                { key: 'insurId', label: this.$t('truck.insurId'), variant: 'primary', sortable: true, },                
                { key: 'insurExpiryDate', label: this.$t('truck.insurExpiryDate'), sortable: true, 
                    formatter: value => {
                        return this.$moment(value).format("DD-MM-YYYY")
                }}, 
                { key: 'vin', label: this.$t('truck.vin'), variant: 'info'},                     
                { key: 'type', label: this.$t('truck.type'),variant: 'info',  sortable: true },                  
                { key: 'make', label: this.$t('truck.make'),variant: 'info',  sortable: true },  
                { key: 'model', label: this.$t('truck.model'), variant: 'info', sortable: true },  
                { key: 'year', label: this.$t('truck.year'), variant: 'info', sortable: true },  
                { key: 'recordAt', label: this.$t('truck.recordAt'), sortable: true, 
                    formatter: value => {
                        return this.$moment(value).format("DD-MM-YYYY")
                }},                
                { key: 'active', label: this.$t('truck.active'), variant: 'primary',sortable: true,
                    formatter: value => {
                        return this.$t(`truck.${value}`)
                }},                
                { key: 'act', label: this.$t('matchTx.actions'), variant: 'danger'}
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
		}
	},

    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
    },
	mounted(){
        this.compId= localStorage.getItem("compId")
        getData( "Truck", 'compId',this.compId, (res)=>{
            this.items = res
            this.totalRows = res.length
        })
	},
	methods:{
        handleHover(hovered) {
            this.isHovered = hovered
        },
        handleHoverEdit(hovered) {
            this.isHoveredEdit = hovered
        },
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.active === false) return 'table-danger'
        },
        showModal() {
            this.$refs['truck-modal'].show()         
        },
        async hideModal() {
            this.$refs['truck-modal'].hide()
        },
        async doSave(){
            let truckId = `T${Math.floor(Math.random() * (900000 - 100000 + 1) + 100000)}`
            let payload = {
                truckId : truckId,
                licensePlate: this.licensePlate,
                vin: this.vin,
                make: this.make,
                model: this.model,
                year: this.year, // Use null initially for numbers
                type: this.type,
                registExpiryDate: Date.parse(this.registExpiryDate), // Will be a string from date input        
                insurId: this.insurId,
                insurExpiryDate: Date.parse(this.insurExpiryDate),
                active: true, // Default to active
                compId : this.compId,       
                recordAt: Date.parse(new Date()),
            }
            await saveWithId('Truck', truckId, payload)
            await this.refresh()
            this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});    
        },
        async handleSave(){
            const licensePlatePattern = /^[\dA-Za-z\p{Script=Thai}]+$/u
            const yearRangeRegex = /^(19[5-9][0-9]|20[0-4][0-9]|2050)$/;
            let msg = 'completed'
            if (this.licensePlate ==='') {
                msg = 'truck.addLicensePlate'
            } else if (!licensePlatePattern.test(this.licensePlate)){
                msg = this.$t('truck.licensePlateFormatMsg')
            } else if (this.registExpiryDate === ''){
                msg = 'truck.addRegistExpiryDate'
            } else if (this.vin ===''){
                msg = 'truck.addVin'
            } else if (this.insurId === ''){
                msg = 'truck.addInsurId'
            } else if (this.insurExpiryDate === ''){
                msg = 'truck.addInsurExpiryDate'     
            } else if (this.type === ''){
                msg = 'truck.addType'                           
            } else if (this.make === ''){
                msg = 'truck.addMake'
            } else if (this.model === ''){
                msg = 'truck.addModel'
            } else if (this.year === ''){
                msg = 'truck.addYear'
            } else if (!yearRangeRegex.test(this.year)){
                msg = this.$t('truck.yearRangeRegexFormatMsg')
            }  
            if (msg === 'completed'){
                // verfy for existing liensePlate? If not, process doSave new Truck.
                await getData('Truck' , 'licensePlate', this.licensePlate , async(res)=>{
                    if (res.length == 0) {
                        await this.doSave()
                    } else {
                        this.showModal()                       
                    }
                })    
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        async doUpdate(){
            let payload = {
                truckId : this.editTruckId,
                licensePlate: this.editLicensePlate,
                vin: this.editVin,
                make: this.editMake,
                model: this.editModel,
                year: this.editYear, // Use null initially for numbers
                type: this.editType,
                registExpiryDate: Date.parse(this.editRegistExpiryDate), // Will be a string from date input        
                insurId: this.editInsurId,
                insurExpiryDate: Date.parse(this.editInsurExpiryDate),
                active: this.editActive, // Default to active
                compId : this.compId,       
                recordAt: Date.parse(new Date()),
            }
            await saveWithId('Truck', this.editTruckId, payload)
            await this.refreshEdit()
            this.process = 'info'
            this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});    
        },
        async handleUpdate(){
            const licensePlatePattern = /^[\dA-Za-z\p{Script=Thai}]+$/u
            const yearRangeRegex = /^(19[5-9][0-9]|20[0-4][0-9]|2050)$/;
            let msg = 'completed'
            if (this.editLicensePlate ==='') {
                msg = 'truck.addLicensePlate'
            } else if (!licensePlatePattern.test(this.editLicensePlate)){
                msg = this.$t('truck.licensePlateFormatMsg')
            } else if (this.editRegistExpiryDate === ''){
                msg = 'truck.addRegistExpiryDate'
            } else if (this.editVin ===''){
                msg = 'truck.addVin'
            } else if (this.editInsurId === ''){
                msg = 'truck.addInsurId'
            } else if (this.editInsurExpiryDate === ''){
                msg = 'truck.addInsurExpiryDate'     
            } else if (this.editType === ''){
                msg = 'truck.addType'                           
            } else if (this.editMake === ''){
                msg = 'truck.addMake'
            } else if (this.editModel === ''){
                msg = 'truck.addModel'
            } else if (this.editYear === ''){
                msg = 'truck.addYear'
            } else if (!yearRangeRegex.test(this.editYear)){
                msg = this.$t('truck.yearRangeRegexFormatMsg')
            }  
            if (msg === 'completed'){
                await this.doUpdate()
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        actUpdate(item) {
            this.editTruckId = item.truckId
            this.editLicensePlate = item.licensePlate
            this.editVin= item.vin
            this.editMake= item.make
            this.editModel= item.model
            this.editYear=  item.year
            this.editType=  item.type
            this.editRegistExpiryDate = this.$moment(item.registExpiryDate ).format("YYYY-MM-DD") 
            this.editInsurId= item.insurId
            this.editInsurExpiryDate = this.$moment(item.insurExpiryDate ).format("YYYY-MM-DD")
            this.editActive = item.active
            this.process = "update"   // to pop up Update subMenu
        }, 
        actStop(item) {
            this.$bvModal.msgBoxConfirm(this.$t('bookingId.confirmStopMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await updateActive( "Truck", item.truckId, false)
                    await this.refresh()                    
                    this.$toasted.show( this.$t('truck.stoped'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 5000});  
                } else {
                return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Suspend: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },
        actAble(item) {
            this.$bvModal.msgBoxConfirm(this.$t('bookingId.confirmAbleMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await updateActive( "Truck", item.truckId , true)
                     this.refresh()                    
                    this.$toasted.show( this.$t('truck.abled'), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 5000});  
                } else {
                return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        }, 
        actDelete(item) {
            this.$bvModal.msgBoxConfirm(this.$t('container.confirmDeleteMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await deleteItem( "Truck", item.truckId)
                    await this.refresh()                    
                    this.$toasted.show( this.$t('container.deleted'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                } else {
                return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },    
        async refresh(){
            await getData( "Truck", 'compId',this.compId, (res)=>{
                this.items = res
                this.totalRows = res.length
                this.licensePlate = ''
                this.vin = ''
                this.make = ''
                this.model = ''
                this.year = null, // Use null initially for numbers
                this.type = ''
                this.registExpiryDate = '' // Will be a string from date input        
                this.insurId = ''
                this.insurExpiryDate = ''
            })
        },
        async refreshEdit(){
            await getData( "Truck", 'compId',this.compId, (res)=>{
                this.items = res
                this.totalRows = res.length
                this.editTruckId = ''
                this.editLicensePlate = ''
                this.editVin= ''
                this.editMake= ''
                this.editModel= ''
                this.editYear=  null
                this.editType=  ''
                this.editRegistExpiryDate = ''
                this.editInsurId= ''
                this.editInsurExpiryDate = ''
            })
        },
    }
}
</script>
<style scoped>

</style>

